import { NavItemType } from 'models';
import { IconAugmentedReality } from '@tabler/icons';

// ==============================|| DIGI-TWIN MENU ITEM ||============================== //

const digiTwin = (): NavItemType => {
  return {
    id: 'digi-twin',
    title: '',
    type: 'group',
    children: [
      {
        id: 'digi-twin-device',
        title: 'navigation.digiTwin.group',
        type: 'item',
        icon: IconAugmentedReality,
        url: 'http://digi-twin.aiems.inohub.sk/',
        external: true,
        target: true
      }
    ]
  };
};

export default digiTwin;
